import ActionButton from '@components/ActionButton';
import { CoreBox } from '@youscience/core';

interface ProfileButtonsProps {
  hasChanges: boolean;
  onSave: (isUpdateForAllStudents?: boolean) => Promise<void>;
  isValid: boolean | undefined;
  showUpdateForAllStudents?: boolean;
}

export const ProfileButtons = ({
  onSave,
  isValid,
  showUpdateForAllStudents = true,
  hasChanges,
}: ProfileButtonsProps) => {
  return (
    <CoreBox sx={{ justifySelf: 'end', alignSelf: 'start', display: 'flex', gap: '.5rem' }}>
      <ActionButton
        variant={showUpdateForAllStudents ? 'outlined' : 'contained'}
        onClick={async () => await onSave()}
        disabled={!isValid || !hasChanges}
        busyText="Saving"
      >
        Save
      </ActionButton>

      {showUpdateForAllStudents ? (
        <ActionButton
          variant="contained"
          disabled={!isValid || !hasChanges}
          busyText="Updating for all students"
          onClick={async () => await onSave(true)}
        >
          Update for all students
        </ActionButton>
      ) : null}
    </CoreBox>
  );
};
